import {create} from "zustand/react";

export const useSearchInputStore = create((set) => ({
  searchingCode: '',
  setSearchingCode: (searchingCode) => {
    set({ searchingCode: searchingCode });
  },
}));